import React from 'react';
import { PropTypes } from 'prop-types';
import Loader from './Loader';

const LoadIcon = ({
  color, height, width, type,
}) => (
  <div className="flex justify-center w-full py-16">
    <Loader type={type} color={color} height={height} width={width} />
  </div>
);

LoadIcon.propTypes = {
  color: PropTypes.string,
  type: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};
LoadIcon.defaultProps = {
  color: '#717171',
  type: 'ThreeDots',
  height: 30,
  width: 30,
};

export default LoadIcon;
